/**
 * Bundle Offer — 연애 티저 다음의 세트 이벤트 페이지 (2026-09-16)
 *
 * /pages/bundle-offer?id={teaserId}
 *   → GET /apps/saju/teaser/:id (티저와 같은 조회)
 *   → productType 이 love 면 선택지를 연다
 *   → 고른 세트(또는 연애 단품) variant 에 입력값 + _teaserId 를 실어 /cart/add.js → /checkout
 *
 * ⚠️ 입력값 키 이름은 서버(getProp)와 1:1 이다. 받은 그대로 넘기고 가공하지 않는다.
 * ⚠️ 고객 이름은 textContent 로만 넣는다 (XSS).
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-bundle-offer]');
  if (!root) return;

  var elLoading = root.querySelector('[data-bo-loading]');
  var elInvalid = root.querySelector('[data-bo-invalid]');
  var elContent = root.querySelector('[data-bo-content]');
  var elCta     = root.querySelector('[data-bo-cta]');
  var opts      = root.querySelectorAll('[data-bo-opt]');

  var ctaPrefix  = root.getAttribute('data-cta-prefix') || '';
  var teaserPath = root.getAttribute('data-teaser-path') || '/pages/teaser-love';

  var teaserId   = new URLSearchParams(window.location.search).get('id') || '';
  var loveVariantId = '';
  var properties = {};

  if (!teaserId) {
    showInvalid();
    return;
  }

  var back = root.querySelector('[data-bo-back]');
  if (back) back.href = teaserPath + '?id=' + encodeURIComponent(teaserId);

  fetch('/apps/saju/teaser/' + encodeURIComponent(teaserId), {
    headers: { Accept: 'application/json' }
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      // 연애 티저를 거친 고객만 — 다른 상품·만료·잘못된 id 는 안내만 한다
      if (!data || !data.ok || data.productType !== 'love' || !data.variantId) {
        showInvalid();
        return;
      }

      loveVariantId = data.variantId;
      properties    = data.input || {};

      var elName = root.querySelector('[data-bo-name]');
      if (elName) elName.textContent = data.name || properties['姓名'] || '';

      hide(elLoading);
      show(elContent);
    })
    .catch(function (err) {
      console.error('[bundle-offer] 조회 실패', err);
      showInvalid();
    });

  // ─── 선택 ────────────────────────────────────────────────────────────────

  root.addEventListener('click', function (e) {
    var opt = e.target.closest('[data-bo-opt]');
    if (opt) {
      select(opt);
      return;
    }
    if (e.target.closest('[data-bo-cta]')) checkout();
  });

  function select(opt) {
    for (var i = 0; i < opts.length; i++) {
      opts[i].setAttribute('aria-checked', opts[i] === opt ? 'true' : 'false');
    }
    if (elCta) {
      elCta.textContent = ctaPrefix + ' ' + opt.dataset.name + ' · HK$' + opt.dataset.price + ' ✦';
    }
  }

  function selected() {
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].getAttribute('aria-checked') === 'true') return opts[i];
    }
    return null;
  }

  // ─── 결제 ────────────────────────────────────────────────────────────────

  function checkout() {
    if (!loveVariantId || !elCta) return;

    var opt = selected();
    // 세트 카드면 그 세트 variant, 단품(또는 선택 없음)이면 연애 단품
    var variantId = (opt && !opt.hasAttribute('data-single') && opt.dataset.variantId)
      ? opt.dataset.variantId
      : loveVariantId;

    elCta.disabled = true;

    // 티저 결제(teaser.js checkout)와 같은 페이로드. "_" 로 시작하는 키는 결제창에 안 보인다
    var props = {};
    Object.keys(properties).forEach(function (key) {
      props[key] = properties[key];
    });
    props._teaserId = teaserId;

    // 담기 전에 장바구니를 비운다.
    // 결제창에서 뒤로 와 다른 세트를 고르면 2줄 주문이 되는데, 서버는 첫 줄만 처리한다
    // → 두 상품 값을 받고 결과지는 하나만 나간다. 이 페이지에서는 언제나 1줄만 결제한다.
    fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('장바구니 비우기 실패: ' + r.status);
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1, properties: props })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('장바구니 담기 실패: ' + r.status);
        return r.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        console.error('[bundle-offer] 결제 연결 실패', err);
        elCta.disabled = false;
        window.location.href = '/cart';
      });
  }

  // 결제창에서 뒤로 가기로 돌아오면 브라우저가 페이지를 그대로 되살려(bfcache)
  // 버튼이 disabled 로 굳는다 → 다시 누를 수 있게 푼다
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && elCta) elCta.disabled = false;
  });

  // ─── 유틸 ────────────────────────────────────────────────────────────────

  function showInvalid() {
    hide(elLoading);
    hide(elContent);
    show(elInvalid);
  }

  function show(node) { if (node) node.hidden = false; }
  function hide(node) { if (node) node.hidden = true; }
})();
